export function getFilteredList(list, itemKeys, excludedItems = false) {
  return list.filter(obj => {
    return Object.keys(obj).some(key =>
      !excludedItems ? itemKeys.includes(key) : !itemKeys.includes(key)
    );
  });
}
